module.exports = __webpack_public_path__ + "static/media/fullsize.99ca43cf.png";